import { EdiMessageType } from '../../enum/edi';
import { BaseDto } from '../base.dto';

export class EdiMessageTypeDto extends BaseDto {
  type: EdiMessageType;
  name: string;
}
